module.exports = __webpack_public_path__ + "static/logo-ink-fedecd4c7842cfd35759a9b5ad493305.png";